import { Phone } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { scrollToId } from "@/lib/scroll";
import { trackCall } from "@/lib/track";

export const ClosingCTA = () => (
  <section className="section" style={{ borderTop: 0, paddingBottom: 0 }} data-testid="closing-cta-section">
    <div className="wrap">
      <Reveal>
        <div className="close-band">
          <h2>Get the bracket. Build the fence yourself.</h2>
          <p style={{ color: "#aebccb", fontSize: 17, marginTop: 16, maxWidth: "50ch" }}>
            Call to order brackets and screws, or send a quote request and we will call you.
          </p>
          <div className="hero-cta">
            <a className="btn btn-primary" href="tel:+18666526569" onClick={() => trackCall("closing-cta")} data-testid="closing-call-btn">
              <Phone size={17} aria-hidden="true" />
              Call to order — 866-652-6569
            </a>
            <button className="btn btn-ghost-dark" onClick={() => scrollToId("quote")} data-testid="closing-quote-btn">
              Request a quote
            </button>
          </div>
          <p className="close-addr">
            DIY Tek Systems, LLC · 4507 S County Rd 1232, Midland, TX 79706
            <br />
            866-652-6569
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
